<i18n>
{
  "fr": {
    "reset-password-title": "Réinitialisation du mot de passe",
    "reset-password-email-sent-text": "Un message pour réinitialiser votre mot de passe a été envoyé à {email}.",
    "return-home-btn": "Retour",
    "reset-password-error-text": "Oh ! Une erreur s'est produite.",
    "resend-reset-password-btn": "M'envoyer le lien de nouveau",
    "user-password-rules": "Votre mot de passe doit avoir une longueur d'au moins 8 caractères, et contenir au moins un chiffre et une lettre majuscule.",
    "new-password-label": "Mot de passe",
    "new-password-confirmation-label": "Confirmation du mot de passe",
    "reset-password-submit-btn": "Soumettre",
    "reset-password-cancel-btn": "Retour",
    "error-reset-password-invalid": "Le mot de passe n'est pas valide",
    "error-reset-password-different": "Le mot de passe doit être le même"
  },
  "en": {
    "reset-password-title": "Password reset",
    "reset-password-email-sent-text": "A message to reset your password has been sent to {email}.",
    "return-home-btn": "Go back",
    "reset-password-error-text": "Oh ! An error has occurred.",
    "resend-reset-password-btn": "Resend link",
    "user-password-rules": "Your password must be minimum 8 characters long, containing at least 1 digit and 1 upper case letter.",
    "new-password-label": "Password",
    "new-password-confirmation-label": "Password confirmation",
    "reset-password-submit-btn": "Submit",
    "reset-password-cancel-btn": "Go back",
    "error-reset-password-invalid": "The password is invalid.",
    "error-reset-password-different": "The password must be the same."
  }
}
</i18n>

<template>
  <welcome>
    <h1 class="title">{{ $t('reset-password-title') }}</h1>
    <template v-if="emailSent">
      <p v-html="$t('reset-password-email-sent-text', { email: `<span class='has-text-weight-medium'>${email}</span>` })"></p>
      <b-button
        class="is-fullwidth mt-32px"
        type="is-link"
        outlined
        size="is-medium"
        tag="input"
        @click="returnHome"
        :value="$t('return-home-btn')"
      />
    </template>
    <template v-else-if="showError">
      <p class="has-text-danger">{{ $t('reset-password-error-text') }}</p>
      <b-button :loading="loading" class="is-fullwidth mt-32px" type="is-link" outlined size="is-medium" @click="resendEmail">
        {{ $t('resend-reset-password-btn') }}
      </b-button>
    </template>
    <template v-else>
      <p class="mb-24px">
        {{ $t('user-password-rules') }}
      </p>
      <s-form ref="form" @submit="resetPassword">
        <s-field
          :label="$t('new-password-label')"
          label-for="password"
          :value="password"
          :rules="rules.passwordRules"
          validate-on-input
        >
          <b-input v-model="password" type="password" id="password"></b-input>
        </s-field>
        <s-field
          :label="$t('new-password-confirmation-label')"
          label-for="passwordConfirmation"
          :value="passwordConfirmation"
          :rules="rules.passwordConfirmationRules"
          validate-on-input
        >
          <b-input v-model="passwordConfirmation" type="password" id="passwordConfirmation"></b-input>
        </s-field>
        <p class="my-32px">
          <b-button :loading="loading" class="is-fullwidth" type="is-link" outlined size="is-medium" native-type="submit">
            {{ $t('reset-password-submit-btn') }}
          </b-button>
        </p>
        <p class="has-text-centered">
          <b-button @click="cancel" type="is-text">{{ $t('reset-password-cancel-btn') }}</b-button>
        </p>
      </s-form>
    </template>
  </welcome>
</template>

<script>
import SForm from '@/components/form/form'
import SField from '@/components/form/field'
import Welcome from '@/components/layout/welcome'

import AuthentificationService from '@/services/authentification'
import UserService from '@/services/user'

import FormHelper from '@/helpers/form'
import { URL_ACCOUNT_LOGIN } from '@/consts/urls'
import { TOKEN_STATUS_INVALID, TOKEN_TYPE_RESET_PASSWORD } from '@/consts/enums'

export default {
  data() {
    return {
      loading: false,
      token: this.$router.currentRoute.query.token,
      email: this.$router.currentRoute.query.email,
      password: '',
      passwordConfirmation: '',
      showError: false,
      emailSent: false,
      rules: {
        passwordRules: [(value) => FormHelper.isValidPassword(value) || this.$t('error-reset-password-invalid')],
        passwordConfirmationRules: [
          (value) => FormHelper.isSame(this.password, value) || this.$t('error-reset-password-different')
        ]
      }
    }
  },
  async mounted() {
    let result = await UserService.verifyToken(this.email, this.token, TOKEN_TYPE_RESET_PASSWORD)

    if (result.status === TOKEN_STATUS_INVALID) {
      this.showError = true
    }
  },
  components: {
    SForm,
    SField,
    Welcome
  },
  methods: {
    resetPassword: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          await UserService.resetPassword(this.email, this.password, this.token)
          await AuthentificationService.login(this.email, this.password)
        } finally {
          this.loading = false
        }
      }
    },
    cancel: function () {
      this.$router.push({
        name: URL_ACCOUNT_LOGIN,
        query: { email: this.email }
      })
    },
    resendEmail: async function () {
      this.loading = true
      try {
        await UserService.sendPasswordReset(this.email)
        this.emailSent = true
      } finally {
        this.loading = false
      }
    },
    returnHome: function () {
      this.$router.push({
        name: URL_ACCOUNT_LOGIN
      })
    }
  }
}
</script>
